import { baseUrl } from '@/api/types';

export function periodicExpenseIndexUrl() {
  return `${baseUrl}/periodic-expenses`;
}

export function periodicExpenseCreateUrl() {
  return `${periodicExpenseIndexUrl()}/create`;
}

export function periodicExpenseEditUrl(invoiceId) {
  return `${periodicExpenseIndexUrl()}/${invoiceId}/edit`;
}

export function periodicExpenseDetailsUrl(invoiceId) {
  return `${periodicExpenseIndexUrl()}/${invoiceId}/details`;
}

export function periodicExpenseStoreUrl() {
  return periodicExpenseIndexUrl();
}

export function periodicExpenseUpdateUrl(invoiceId) {
  return `${periodicExpenseIndexUrl()}/${invoiceId}`;
}

export function periodicExpenseDeleteUrl(invoiceId) {
  return `${periodicExpenseIndexUrl()}/${invoiceId}`;
}

export function periodicExpensePauseUpdateUrl(invoiceId) {
  return `${baseUrl}/periodic-expenses/pause/${invoiceId}`;
}

export function periodicExpenseRequisitesIndexUrl(invoiceId) {
  return `${baseUrl}/periodic-expenses-requisites/${invoiceId}`;
}
